import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export function bucketEndpointMiddleware(options) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var endpoint, bucket, bucketEndpointUrl, _context$logger, _context$logger$const, warning, _context$logger2, _context$logger2$warn;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!options.bucketEndpoint) {
                  _context.next = 15;
                  break;
                }
                endpoint = context.endpointV2;
                if (!endpoint) {
                  _context.next = 15;
                  break;
                }
                bucket = args.input.Bucket;
                if (!(typeof bucket === "string")) {
                  _context.next = 15;
                  break;
                }
                _context.prev = 5;
                bucketEndpointUrl = new URL(bucket);
                context.endpointV2 = _objectSpread(_objectSpread({}, endpoint), {}, {
                  url: bucketEndpointUrl
                });
                _context.next = 15;
                break;
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](5);
                warning = "@aws-sdk/middleware-sdk-s3: bucketEndpoint=true was set but Bucket=".concat(bucket, " could not be parsed as URL.");
                if (((_context$logger = context.logger) === null || _context$logger === void 0 ? void 0 : (_context$logger$const = _context$logger.constructor) === null || _context$logger$const === void 0 ? void 0 : _context$logger$const.name) === "NoOpLogger") {
                  console.warn(warning);
                } else {
                  (_context$logger2 = context.logger) === null || _context$logger2 === void 0 ? void 0 : (_context$logger2$warn = _context$logger2.warn) === null || _context$logger2$warn === void 0 ? void 0 : _context$logger2$warn.call(_context$logger2, warning);
                }
                throw _context.t0;
              case 15:
                return _context.abrupt("return", next(args));
              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 10]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
}
export var bucketEndpointMiddlewareOptions = {
  name: "bucketEndpointMiddleware",
  override: true,
  relation: "after",
  toMiddleware: "endpointV2Middleware"
};